import React, { Component, PureComponent } from 'react';
import {
	Collapse,
	Container,
	Button,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem } from 'reactstrap';
import { A, BlessLink, R } from './routes';

import Butt from './c/Butt';
import Bubble from './c/Bubble';
import Footer from './c/Footer';
import { SignupLoginModal, OpenLogin, OpenSignup } from './c/SignupLogin';
import BeforeWeLetYouIn from './c/BeforeWeLetYouIn';
import { connect } from 'react-redux';
import './NotificationsService';
import { TradeModal } from './c/Trade';
import { T, TraksConsumer } from './traks';
import SearchField from './c/SearchField';
import {
	ModalContainer,
	ModalContainerContent,
} from './Modal';
import store from './store';
import API from './API';
import { AUAContainer } from './AUA';
import { TickerTape } from './c/TickerTape';
import { is_app } from './App';
import OurLogo from './c/OurLogo';
import { site_name } from './Site';

function get_language_stuff(lang) {
	const switch_text_classes = "pl-2";
	const lang_icon_classes = "ad_lang_img ad_margin_bottom_2px";
	if (IS_AKTIEDYSTEN_DK) {
		return {
			en: {
				icon: <img alt="en" src="/gfx/usa-icon-0.svg" className={lang_icon_classes}/>,
				switch_text: <span className={switch_text_classes}>English</span>,
			},
			da: {
				icon: <img alt="da" src="/gfx/denmark-icon-0.svg" className={lang_icon_classes}/>,
				switch_text: <span className={switch_text_classes}>Dansk</span>,
			},
			switch_to_lang: {da: "en", en: "da"}[lang],
		};
	} else if (IS_AKTIEKAMPEN_SE) {
		return {
			en: {
				icon: <img alt="en" src="/gfx/usa-icon-0.svg" className={lang_icon_classes}/>,
				switch_text: <span className={switch_text_classes}>English</span>,
			},
			sv: {
				icon: <img alt="sv" src="/gfx/sweden-icon-0.svg" className={lang_icon_classes}/>,
				switch_text: <span className={switch_text_classes}>Svensk</span>,
			},
			switch_to_lang: {sv: "en", en: "sv"}[lang],
		};
	} else if (IS_INVESTSPIEL_DE) {
		return {
			en: {
				icon: <img alt="en" src="/gfx/usa-icon-0.svg" className={lang_icon_classes}/>,
				switch_text: <span className={switch_text_classes}>English</span>,
			},
			de: {
				icon: <img alt="de" src="/gfx/germany-icon-0.svg" className={lang_icon_classes}/>,
				switch_text: <span className={switch_text_classes}>Deutsch</span>,
			},
			switch_to_lang: {de: "en", en: "de"}[lang],
		};
	} else if (IS_TRADERR_COM) {
		return null;
	}
}

function mk_switch_element(props) {
	const stuff = get_language_stuff(props.lang);
	if (!stuff) return null;

	const switch_fn = (e) => { props.set_lang(stuff.switch_to_lang); e.preventDefault(); };
	return (
		<DropdownItem className="pl-3 py-3 font-small ad_gray_fg" onClick={switch_fn} href="#">
			{stuff[stuff.switch_to_lang].icon}
			{stuff[stuff.switch_to_lang].switch_text}
		</DropdownItem>
	);
}

function LangNavDropDownItemInner(props) {
	return mk_switch_element(props);
}
function LangNavDropDownItem(props) {
	return <TraksConsumer><LangNavDropDownItemInner/></TraksConsumer>;
}

function LangNavItemInner(props) {
	const stuff = get_language_stuff(props.lang);
	if (!stuff) return null;
	const lang_icon = stuff[props.lang].icon;
	return (
		<NavItem>
			<UncontrolledDropdown className="d-none d-md-block">
				<DropdownToggle nav className="ad_no_outline_focus">
					{lang_icon}
				</DropdownToggle>
				<DropdownMenu>
					{mk_switch_element(props)}
				</DropdownMenu>
			</UncontrolledDropdown>
		</NavItem>
	);
}

function LangNavItem(props) {
	return <TraksConsumer><LangNavItemInner/></TraksConsumer>;
}

function LangNavLinkInner(props) {
	const stuff = get_language_stuff(props.lang);
	if (!stuff) return null;
	const switch_fn = (e) => {
		e.preventDefault();
		props.set_lang(stuff.switch_to_lang);
		props.on_action();
	};
	return (
		<NavLink href="#" onClick={switch_fn}>
			<span className="ad_navbar_textlink pl-md-2">{stuff[stuff.switch_to_lang].icon}{stuff[stuff.switch_to_lang].switch_text}</span>
		</NavLink>
	);
}

function LangNavLink(props) {
	return <TraksConsumer><LangNavLinkInner {...props}/></TraksConsumer>;
}

function InspirationInner(text_css = "ad_navbar_textlink_dark") {
	return (<React.Fragment>
		<NavLink href="https://inspiration.aktiedysten.dk" className="d-flex">
			<img alt="inspiration" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/explore-icon-2023-0.svg"/>
			<span className={"pl-2 " + text_css}><T>Inspiration &amp; news</T></span>
		</NavLink>
		<NavLink href="https://sammen.aktiedysten.dk" className="d-flex">
			<img alt="inspiration" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/handshake-icon-2023-0.svg"/>
			<span className={"pl-2 " + text_css}><T>Cooperate with {site_name}</T></span>
		</NavLink>
		<NavLink href="https://undervisning.aktiedysten.dk" className="d-flex">
			<img alt="undervisning" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/education-icon-2023-0.svg"/>
			<span className={"pl-2 " + text_css}><T>Education</T></span>
		</NavLink>
	</React.Fragment>);
}

function FAQOrInspiration(close) {
		let faqOrInspiration = (
			<ActionNavLink href="/faq" on_action={close}>
				<img alt="faq" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/faq-icon-2023-0.svg"/>
				<span className="ad_navbar_textlink pl-2">FAQ</span>
			</ActionNavLink>
		);

		if(IS_AKTIEDYSTEN_DK) {
			faqOrInspiration = (
				<NavItem>
					<UncontrolledDropdown className="d-none d-md-block">
						<DropdownToggle nav className="ad_no_outline_focus">
							<img alt="inspiration" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/explore-icon-2023-0.svg"/>
							<span className="ad_navbar_textlink pl-2"><T>Inspiration</T></span>
						</DropdownToggle>
						<DropdownMenu>
						{InspirationInner()}
						</DropdownMenu>
					</UncontrolledDropdown>
					<span className='d-md-none'>
						{InspirationInner("ad_navbar_textlink")}
					</span>
				</NavItem>
			);
		}

		return faqOrInspiration;
}

const G = (props) => props.children;

class DynamicSpacer extends Component {
	constructor(props) {
		super(props);
		this.anim_frame = null;
		this.state = {spacing: 0};
	}

	componentWillUnmount() {
		if (this.anim_frame !== null) {
			window.cancelAnimationFrame(this.anim_frame);
			this.anim_frame = null;
		}
	}

	render() {
		var rq; rq = () => {
			if (this.anim_frame !== null) window.cancelAnimationFrame(this.anim_frame);
			this.anim_frame = window.requestAnimationFrame(() => {
				this.anim_frame = null;
				const em = document.getElementById(this.props.element_id);
				if (em) {
					const bbox = em.getBoundingClientRect();
					const height = bbox.bottom - bbox.top;
					this.setState({spacing: height});
				}
				rq();
			});
		}
		rq();
		return <div style={{paddingTop: this.state.spacing}}/>;
	}
}

function ActionNavLink(props) {
	const pass_props = {...props};
	delete pass_props.on_action;
	delete pass_props.children;
	const click = (e) => {
		props.on_action();
	};
	return <span onClick={click} onKeyDown={click}><BlessLink><NavLink {...pass_props}>{props.children}</NavLink></BlessLink></span>;
}

class Topbar extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {is_open: false};
	}

	logout() {
		R.replace("/logout");
	}

	render_navbar_items_logged_in(close) {
		const logout = (e) => {
			close();
			this.logout();
		};

		return (
			<G>
				<NavItem>
					<ActionNavLink on_action={close} href="/games">
						<img alt="new game" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/games-icon-2023-0.svg"/>
						<span className="ad_navbar_textlink pl-2 pr-3"><T>Games</T></span>
					</ActionNavLink>
				</NavItem>
				<NavItem className="d-md-none">
					<ActionNavLink on_action={close} href="/achievements">
						<img alt="achievements" src="/gfx/achievements-icon-navbar-0.svg"/>
						<span className="ad_navbar_textlink pl-2"><T>Achievements</T></span>
					</ActionNavLink>
				</NavItem>
				{IS_AKTIEDYSTEN_DK && <NavItem className="d-md-none">
					<a href="https://inspiration.aktiedysten.dk/">
						<img alt="inspiration" className="ad_margin_bottom_2px" src="/gfx/lightbulb-icon-navbar-0.svg"/>
						<span className="ad_navbar_textlink pl-2">Inspiration</span>
					</a>
				</NavItem>}
				<NavItem className="d-md-none">
					<ActionNavLink on_action={close} href="/trade_history">
						<img alt="trade_history" src="/gfx/trade-icon-navbar-0.svg"/>
						<span className="ad_navbar_textlink pl-2"><T>Trade history</T></span>
					</ActionNavLink>
				</NavItem>
				<NavItem className="d-md-none">
					<ActionNavLink on_action={close} href="/preferences">
						<img alt="preferences" src="/gfx/gear-icon-navbar-0.svg"/>
						<span className="ad_navbar_textlink pl-2"><T>Preferences</T></span>
					</ActionNavLink>
				</NavItem>
				<NavItem>
					<ActionNavLink on_action={close} className="mt-md-2 pt-md-1 p-md-0" href="/notifications">
						<div className="ad_navbar_textlink pl-md-3 pr-2 ad_notification_container ad_navbar_vertical_line_element">
							<span className="d-none d-md-block">
								<img alt="notifications" className="ad_notification" src="https://static.aktiedysten.dk/gfx/notification-icon-green-2023-0.svg"/>
							</span>
							<span className="d-md-none">
								<img alt="notifications" className="ad_notification" src="/gfx/notification-icon-0.svg"/>
							</span>
							<div className="ad_notification_bubble">
								<Bubble value={this.props.unseen_notifications}/>
							</div>
							<span className="d-md-none pl-2"><T>Notifications</T></span>
						</div>
					</ActionNavLink>
				</NavItem>
				<NavItem className="d-md-none">
					<LangNavLink on_action={close}/>
				</NavItem>
				<NavItem className="d-md-none">
					<ActionNavLink on_action={logout} href="/">
						<img alt="signout" src="/gfx/signout-icon-navbar-0.svg"/>
						<span className="ad_navbar_textlink pl-2"><T>Logout</T></span>
					</ActionNavLink>
				</NavItem>
			</G>
		)
	}

	render_navbar_items_not_logged_in(close) {
		return (
			<NavItem>
				<BlessLink><NavLink href="/games">
					<img alt="new game" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/games-icon-2023-0.svg"/>
					<span className="ad_navbar_textlink pl-2 pr-3"><T>Games</T></span>
				</NavLink></BlessLink>
				<div className="d-md-none"><LangNavLink on_action={close}/></div>
			</NavItem>
		)
	}

	render_navbar_menu_logged_in() {
		const logout = (e) => {
			e.preventDefault();
			this.logout();
		};
		return (
			<G>
				<NavItem>
					<UncontrolledDropdown className="d-none d-md-block">
						<DropdownToggle nav className="ad_no_outline_focus">
								<img className="ad_avatar" alt="user" src="https://static.aktiedysten.dk/gfx/user-icon-green-2023-0.svg"/>
						</DropdownToggle>
						<DropdownMenu right>
							<LangNavDropDownItem/>
							<BlessLink><DropdownItem className="ad_dropdown_top_line py-3 font-small ad_gray_fg" href="/achievements"><img alt="achievements" className="pl-3 pr-2 ad_margin_bottom_1px" src="/gfx/achievements-icon-0.svg"/><T>Achievements</T></DropdownItem></BlessLink>
							<BlessLink><DropdownItem className="ad_dropdown_top_line py-3 font-small ad_gray_fg" href="/trade_history"><img alt="trades" className="pl-3 pr-2 ad_margin_bottom_1px" src="/gfx/trade-icon-dropdown-0.svg"/><T>Trade history</T></DropdownItem></BlessLink>
							<BlessLink><DropdownItem className="ad_dropdown_top_line py-3 font-small ad_gray_fg" href="/preferences"><img alt="preferences" className="pl-3 pr-2 ad_margin_bottom_1px" src="/gfx/gear-icon-0.svg"/><T>Preferences</T></DropdownItem></BlessLink>
							<DropdownItem className="ad_dropdown_top_line py-3 font-small ad_gray_fg" href="#" onClick={logout}><img alt="logout" className="pl-3 pr-2 ad_margin_bottom_1px" src="/gfx/signout-icon-0.svg"/><T>Logout</T></DropdownItem>
						</DropdownMenu>
					</UncontrolledDropdown>
				</NavItem>
			</G>
		);
	}

	render_navbar_menu_not_logged_in_lang_select() {
		return (
			<Nav>
				<LangNavItem/>
			</Nav>
		);
	}

	render_navbar_menu_not_logged_in(close) {
		const login = () => { close(); OpenLogin(); }
		const signup = () => { close(); OpenSignup(); }
		return (
			<div className="ad_login_navbar_button">
				<Button size="sm" className="ad_login_button px-3 mr-2" onClick={login}><T>Login</T></Button>
				<Butt size="sm" className="ad_signup_button px-3" onClick={signup}><T>Sign up</T></Butt>
			</div>
		);
	}

	render() {
		var toggler_classes = ["ad_no_outline_focus"];
		var bubble;
		if (!this.state.is_open) {
			toggler_classes.push("collapsed");
			bubble = (
				<div className="ad_burger_bubble">
					<Bubble value={this.props.unseen_notifications}/>
				</div>
			);
		}

		toggler_classes = toggler_classes.join(" ");

		/* subtlety: both can be false (props.me is intially false,
		 * then null if /a/whoami returns "not logged in")  */
		var is_logged_in = !!this.props.me;
		var not_logged_in = this.props.me === null;

		const toggle = () => {
			this.setState((prev_state) => ({
				is_open: !prev_state.is_open
			}));
		};

		const close = () => {
			this.setState({is_open: false});
		};

		var nav_classes = "pr-0 pr-sm-3";

		if(is_app) {
			nav_classes += " ad_pt_30px";
		}

		const brand = <OurLogo className="pr-md-3"/>

		return (
			<div>
				<Navbar expand="md" dark fixed="top" className={nav_classes} id="main_topbar">
					<Container>
						<BlessLink><NavbarBrand className="ad_no_outline_focus" href="/">
							{brand}
						</NavbarBrand></BlessLink>

						<div className="ad_burger_container d-block d-md-none">
							<NavbarToggler onClick={toggle} className={toggler_classes}/>
							{bubble}
						</div>
						<Collapse isOpen={this.state.is_open} navbar>
							<Nav navbar className="mr-auto">
								<NavItem>
									<SearchField form_classes="pt-3 pt-md-0 pb-2 pb-md-0" on_action={close} input_id="search_field_0"/>
								</NavItem>
							</Nav>
							<Nav navbar className="ml-auto">
								<NavItem>
									{FAQOrInspiration(close)}
								</NavItem>
								<NavItem>
									<ActionNavLink on_action={close} className="" href="/explore">
										<img alt="explore" className="ad_margin_bottom_2px" src="https://static.aktiedysten.dk/gfx/market-icon-2023-0.svg"/>
										<span className="ad_navbar_textlink pl-2"><T>Markets</T></span>
									</ActionNavLink>
								</NavItem>
								{ is_logged_in && this.render_navbar_items_logged_in(close) }
								{ not_logged_in && this.render_navbar_items_not_logged_in(close) }
							</Nav>
							{not_logged_in && this.render_navbar_menu_not_logged_in_lang_select() }
							<Nav className="">
								{ is_logged_in && this.render_navbar_menu_logged_in() }
								{ not_logged_in && this.render_navbar_menu_not_logged_in(close) }
							</Nav>
						</Collapse>
					</Container>
				</Navbar>
				<DynamicSpacer element_id="main_topbar"/>
				<TickerTape/>
			</div>
		);
	}
}

Topbar = connect(
	(state) => ({me: state.me, unseen_notifications: state.unseen_notifications})
)(Topbar);

class PleaseGiveUsYourEmailNagBoxInner extends Component {
	constructor(props) {
		super(props);
		this.state = {email: "", err: ""};
	}

	render() {
		const go_away = () => {
			store.dispatch_value("just_logged_in_with", null);
		};

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		const { aua } = this.props;

		const can_submit = this.state.email.trim().length > 0;

		const validate_and_post = (e) => {
			e.preventDefault();
			aua.request.set_email_password(null, this.state.email, null, false, (err) => {
				var new_state = {err: ""}
				if (err) {
					new_state.err = err.code;
				} else {
					go_away();
				}
				this.setState(new_state);
			});
		};

		var has_email_input_error = false;
		var error_element;
		switch (this.state.err) {
		case "": break;
		case "email_conflict":
			error_element = <span><T>The email address is being used by another account</T></span>;
			has_email_input_error = true;
			break;
		case "email_invalid":
			error_element = <span><T>You must enter a valid email address</T></span>;
			has_email_input_error = true;
			break;
		default:
			error_element = <span>{this.state.err}</span>;
			break;
		}

		const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

		return (
			<div className="ad_email_nagging_box ad_email_nagging_box_placement">
				<div className="px-4 pt-3 ad_150pct ad_text_blackish pb-2"><b><T>We're missing your e-mail</T></b></div>
				<div className="px-4 font-90 ad_profile_gray pt-3">
				<T>We need your e-mail to send you updates about your games,
				platform enhancements, tips &amp; tricks and more.
				</T>
				</div>
				<div className="px-4 ad_profile_gray font-90 py-3">
				<T>You can always change you email settings <A className="ad_blue_link" href="/preferences">here</A>.</T>
				</div>
				<div className="px-4 ad_email_nag_input_txt ad_profile_gray"><T>E-MAIL ADDRESS:</T></div>
				<form onSubmit={validate_and_post}>
				<div className="px-4 py-2"><input type="email" name="email" value={this.state.email} onChange={change} className={errcls(has_email_input_error, "add_profile_gray form-control p-3")} />
				</div>
				{error_element && <div className="px-4 pb-4 errors">{error_element}</div>}
				<div className="px-4 pt-4 pb-2"><Button disabled={!can_submit} type="submit" className="ad_new_game_button w-100"><T>Add e-mail</T></Button></div>
				<div className="px-4 pb-4"><Button onClick={go_away} className="ad_no_thanks_button w-100"><T>No thanks!</T></Button></div>
				</form>
			</div>
		);
	}
}

const NagBox = (props) => {
	return (
		<div className="ad_email_nagging_box ad_email_nagging_box_placement">
			{props.children}
		</div>
	);
};


class VerifyEmailNagBoxInner extends Component {
	constructor(props) {
		super(props);
		const { aua } = props;
		this.state = {
			email: aua.me.LocalEmail,
			auth_password: "",
			err: "",
			cooldown: false,
		};
		this.timeout = undefined;
	}

	componentWillUnmount() {
		if (this.timeout !== undefined) {
			clearTimeout(this.timeout);
			this.timeout = undefined;
		}
	}

	render() {
		const { aua } = this.props;
		const { auth, me, lang } = aua;
		const trl = (x) => x.trim().toLowerCase();
		const is_different_email = trl(this.state.email) !== trl(me.LocalEmail);

		const compulsory_passwd_auth = auth === "passwd";

		const validate_and_post = (do_execute) => {
			if (do_execute) this.setState({cooldown: true});

			const dryrun = !do_execute;

			if (is_different_email) {
				aua.request.set_email_password(this.state.auth_password, this.state.email, null, dryrun, (err) => {
					var new_state = {err: "", cooldown: false};
					if (err) {
						new_state.err = err.code;
					} else {
						new_state.cooldown = true;
						this.timeout = setTimeout(() => {
							this.setState({cooldown: false});
						}, 12500);
					}
					this.setState(new_state);
				});
			} else {
				API.post("/a/resend_verification_email", {lang}, (response, status) => {
					this.timeout = setTimeout(() => {
						this.setState({cooldown: false});
					}, 12500);
				});
			}
		};

		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		const submit = (e) => {
			e.preventDefault();
			validate_and_post(true);
		};

		const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

		var has_email_input_error = false;
		var has_auth_password_input_error = false;
		var error_element;
		switch (this.state.err) {
		case "": break;
		case "auth_error":
			error_element = <span><T>Wrong password</T></span>;
			has_auth_password_input_error = true;
			break;
		case "email_conflict":
			error_element = <span><T>The email address is being used by another account</T></span>;
			has_email_input_error = true;
			break;
		case "email_invalid":
			error_element = <span><T>You must enter a valid email address</T></span>;
			has_email_input_error = true;
			break;
		default:
			error_element = <span>{this.state.err}</span>;
			break;
		}

		const email_is_login = me.HasPassword;

		const input_title = email_is_login ? <span><T>LOGIN / EMAIL:</T></span> : <span><T>EMAIL</T></span>;

		const require_password = compulsory_passwd_auth && is_different_email;

		var current_password_element;
		if (require_password) {
			current_password_element = (
				<div className="px-4 py-2 mb-3">
					<div className="ad_email_nag_input_txt ad_profile_gray">
						<T>Enter your current password to change your email:</T>
					</div>
					<input
						className={errcls(has_auth_password_input_error, "form-control p-3")}
						type="password"
						name="auth_password"
						disabled={this.state.cooldown}
						value={this.state.auth_password}
						onChange={change}
					/>
				</div>
			);
		}

		const can_submit = !require_password || this.state.auth_password.length > 0;

		const But = (props) => <Button type="submit" className="ad_new_game_button w-100" disabled={this.state.cooldown || !can_submit}>{props.children}</Button>;

		const clicky = is_different_email
			? (<But><T>Change login/email and send email</T></But>)
			: (<But><T>Resend email</T></But>);

		const current_email = me.LocalEmail;

		const explanation = email_is_login
			? <T>It contains a link you must click in order to keep your account active.</T>
			: <T>It contains a link you must click to verify your email.</T>

		return (
			<NagBox>
				<div className="px-4 pt-4 ad_150pct ad_text_blackish pb-3"><b><T>Please verify your email</T></b></div>
				<div className="px-4 font-90 ad_profile_gray py-3">
				<T>We've sent you a verification email to <tt>{current_email}</tt>.</T>&nbsp;
				{explanation}
				</div>
				<div className="px-4 ad_email_nag_input_txt ad_profile_gray">{input_title}</div>
				<form onSubmit={submit}>
					<div className="px-4 py-2">
						<input
							disabled={this.state.cooldown}
							className={errcls(has_email_input_error, "form-control p-3")}
							type="email"
							name="email"
							onChange={change}
							value={this.state.email}
						/>
					</div>
					{current_password_element}
					{error_element && <div className="px-4 pb-4 errors">{error_element}</div>}
					<div className="px-4 pb-4">
						{clicky}
					</div>
				</form>
			</NagBox>
		);
	}
}

const VerifyEmailNagBox = (props) => <AUAContainer><VerifyEmailNagBoxInner {...props}/></AUAContainer>;
const PleaseGiveUsYourEmailNagBox = (props) => <AUAContainer><PleaseGiveUsYourEmailNagBoxInner {...props}/></AUAContainer>;

const PotentialNagBox = connect(
	(state) => ({
		me: state.me,
		has_unverified_email: state.has_unverified_email,
		just_logged_in_with: state.just_logged_in_with,
	})
)((props) => {
	if (!props.me) {
		return null;
	}

	return null;

	if ((props.just_logged_in_with === "fb" || props.just_logged_in_with === "twtr") && props.me && !props.me.LocalEmail && props.me.Epoch === 1) {
		return <PleaseGiveUsYourEmailNagBox/>;
	} else if (props.has_unverified_email) {
		return <VerifyEmailNagBox/>;
	} else {
		return null;
	}
});

const FFFFFFFFFFFFFFFFFFFFFFUU = connect(
	(state) => ({ me: state.me })
)((props) => {
	/* XXX This probably violates all good practices, even ones not
	 * invented yet. The problem I'm trying to solve is to display
	 * BeforeWeLetYouIn.Modal conditionally based on "me", and also what
	 * page I'm visiting; it's stuff like "we need to block access to the
	 * site until user has accepted our terms, UNLESS they're visiting the
	 * terms page, in which case it's silly to force the user to accept the
	 * terms before the user can read the terms". Things I've tried:
	 *
	 *  - since Redux is basically the master of both the user object
	 *    ("me") and the "modal stack", I thought I could solve it in
	 *    store.js, however, importing ./c/BeforeWeLetYouIn in store.js has
	 *    side-effects that breaks the site (and if I fixed that, I'd still
	 *    have to figure out which page I'm on)
	 *
	 *  - "BeforeWeLetYouIn" derives from the old RequireEmailModal which
	 *    was triggered in index.js. This almost works, except that
	 *    index.js is kind of a "bootloader", and only executes once. This
	 *    leads to sillyness where you can login without encountering the
	 *    modal, but after a refresh/revisit you see it...
	 *
	 *  - The same as here, but without setTimeout(..., 0); React complains
	 *    about state-changes occuring in the render method ("Warning:
	 *    Cannot update during an existing state transition (such as within
	 *    `render`). Render methods should be a pure function of props and
	 *    state.")
	 *
	 * I'm sure the REAL problem is that I haven't seen Martin Fowler's
	 * latest webinar about the Show-Modal-In-React pattern that "fixes
	 * everything", and not THAT I'M WRITING CODE ON TOP OF 20 MILLION
	 * LINES OF BROWSER CODE, AND ALSO 300k LINES OF REACT CODE WHICH ONLY
	 * EXISTS TO FIX PROBLEMS WITH THE OTHER 20 MILLION LINES OF CODE.
	 */
	if (props.allow_nagbox) {
		setTimeout(() => {
			BeforeWeLetYouIn.open_if_required(props.me)
		}, 0);
	}
	return null; // we're not here to render, bro!
});

const MainImpl = (props) => {
	return (
		<ModalContainer>
			<ModalContainerContent>
				<Topbar/>
				<main role="main" className="container-fluid p-0">
					{props.child}
				</main>
				<Footer/>
				{props.allow_nagbox && <PotentialNagBox/>}
				<FFFFFFFFFFFFFFFFFFFFFFUU allow_nagbox={props.allow_nagbox}/>
			</ModalContainerContent>
			<TradeModal/>
			<SignupLoginModal/>
			<BeforeWeLetYouIn.Modal/>
		</ModalContainer>
	);
}

const Main = (props) => <MainImpl allow_nagbox={true} {...props}/>
const MainNoNagbox = (props) => <MainImpl allow_nagbox={false} {...props}/>

export {
	Main,
	MainNoNagbox,
}



// WEBPACK FOOTER //
// ./src/Main.js